import type { PageMeta } from '../../../lib/permissions/pageMeta'
import POSSessionsPage from '../../pos/POSSessionsPage'

export const pageMeta: PageMeta = {
  key: 'sell.pos_sessions',
  label: 'POS Sessions',
  module: 'Trading',
  section: 'Sell',
  description: 'POS session history',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'view', viewer: 'view',
  },
}

export default function POSSessionsTab() {
  return <POSSessionsPage />
}
